import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { DEFAULT_SIGNING_MUTATION_PARAMS } from "@/modules/patients/detail/conclude/services/useDocumentSigning"
import {
  Ch_signSickLeaveDocumentInput,
  useChSignSickLeaveMutation as useChSignSickLeaveMutationType,
} from "@/modules/patients/detail/therapy-prescription/ch/services/__generated__/useChSignSickLeaveMutation.graphql"

const mutation = graphql`
  mutation useChSignSickLeaveMutation($input: Ch_signSickLeaveDocumentInput!) {
    ch_signSickLeaveDocument(input: $input) {
      ch_SickLeave {
        id
        createdAt
        createdBy
        signedBy
        signedAt
        updatedAt
        updatedBy
        fileId
        ...chSickLeaveFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useChSignSickLeaveMutationType>, "variables"> & {
  id: Ch_signSickLeaveDocumentInput["id"]
}

const useChSignSickLeaveMutation = () => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChSignSickLeaveMutationType>(
    mutation,
    DEFAULT_SIGNING_MUTATION_PARAMS,
  )

  const commitHandler = useCallback(
    async (config: Config) => {
      commit({
        variables: {
          input: {
            id: config.id,
          },
        },
        ...config,
      })
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChSignSickLeaveMutation }
